let Config = {
    ONESIGNAL_API_URL : "https://onesignal.com/api/v1/notifications",
    ONESIGNAL_APP_ID : "c15304d8-dd12-4311-ba18-761182661338", //LIVE KEY (NO STAGING ID)
    ONESIGNAL_Authorization :  `Basic NTEzYWM4NmItMGU2Ny00MzVjLWJhM2UtNjU5NTM1OGMxYmM3`,
    ONESIGNAL_GROUP : 200 //GROUP RUNNER DATA IN 200 RUNNER ARRAY
}

export {Config}


// WEBPACK FOOTER //
// ./src/config.js